import { CtaButton } from '@tkww/orion-web-ds-action';
import {
	GridColumn,
	GridContainer,
	GridRow,
} from '@tkww/orion-web-ds-structure';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import constants from '../../../../../constants/best_of_weddings';
import VendorHelper from '../../../../../helpers/vendor';
import { tkProUrl } from '../../../../../settings';
import { formatCityStateCode } from '../../../../../utils/formatUrls';
import { SORT_DIRECTIONS } from '../../../../../utils/sortParam';
import { awardsInfo } from '../../../../utils/awardsInfo';
import BOWCard from './BOWCard';
import BowSection from './BowSection';
import BowSelectionProcess from './BowSelectionProcess';
import Header from './header';
import Styles from './styles.scss';

const { bow, hof } = awardsInfo();

export default class ResultsComponent extends Component {
	static propTypes = {
		awardType: PropTypes.object.isRequired,
		category: PropTypes.object.isRequired,
		isFetching: PropTypes.bool.isRequired,
		location: PropTypes.object.isRequired,
		searchCompleted: PropTypes.bool.isRequired,
		totalBOWVendors: PropTypes.number.isRequired,
		vendors: PropTypes.arrayOf(PropTypes.object).isRequired,
	};

	shouldComponentUpdate(nextProps) {
		this.redirectIfBOWButNotPaid(nextProps);
		this.redirectIfNoVendorsHOF(nextProps);
		return true;
	}

	redirectIfBOWButNotPaid(nextProps) {
		return this.shouldRedirect(nextProps) ? this.redirectToSearch() : false;
	}

	buildRedirectRoute(category, cityAndState, awardType) {
		return `/marketplace/${category.slug}-${cityAndState}/${awardType.slug}?sort=${SORT_DIRECTIONS.featured.type}`;
	}

	redirectIfNoVendorsHOF(nextProps) {
		const { awardType, category, location, searchCompleted, vendors } =
			nextProps;

		if (
			awardType.name === constants.HALL_OF_FAME.name &&
			vendors.length === 0 &&
			searchCompleted
		) {
			const cityAndState = formatCityStateCode(location);
			window.location.assign(
				this.buildRedirectRoute(category, cityAndState, awardType),
			);
		}
	}

	shouldRedirect(nextProps) {
		return (
			nextProps.totalBOWVendors === 0 && this.searchDoneNoPaidResults(nextProps)
		);
	}

	redirectToSearch() {
		window.location.assign(this.redirectUrl());
	}

	redirectUrl() {
		const { location, category, awardType } = this.props;
		const cityAndState = formatCityStateCode(location);

		return this.buildRedirectRoute(category, cityAndState, awardType);
	}

	searchDoneNoPaidResults(nextProps) {
		if (nextProps) {
			return (
				!nextProps.isFetching &&
				nextProps.searchCompleted &&
				nextProps.vendors.length === 0
			);
		}
		return false;
	}

	shouldDisplayBowInfo() {
		return this.props.vendors.length === 0 && this.isBOWAwardSearch();
	}

	isBOWAwardSearch() {
		return !!(this.props.awardType.slug === bow.slug);
	}

	isHOFAwardSearch() {
		return !!(this.props.awardType.slug === hof.slug);
	}

	renderBowInfo() {
		return (
			<div>
				<BowSelectionProcess />
			</div>
		);
	}

	writeReviewText() {
		const title = 'Review Your Vendor Team';
		const body =
			"Want to help your vendors get a spot on next year's list? Write a review! You'll be helping other couples find top pros for their wedding too.";

		return <BowSection title={title} body={body} />;
	}

	renderHeader() {
		return (
			<React.Fragment>
				<GridRow>
					<GridColumn lg="12">
						<Header
							searchDoneNoPaidResults={this.searchDoneNoPaidResults()}
							awardType={this.props.awardType}
							category={this.props.category}
							headerOnly={this.props.vendors.length > 0}
						/>
					</GridColumn>
				</GridRow>
			</React.Fragment>
		);
	}

	render() {
		return (
			<>
				<GridRow>
					<GridColumn lg="1" />
					<GridColumn lg="10" className={Styles.resultsSection}>
						{this.renderHeader()}
						{this.props.vendors.length > 0 && (
							<GridRow>
								{this.props.vendors.map((vendor, index) => (
									<BOWCard
										category={this.props.category}
										key={vendor.id}
										vendor={vendor}
										index={index + 1}
									/> // These need to be 1-based
								))}
							</GridRow>
						)}
						<GridRow>
							<GridColumn lg="12">
								<CtaButton
									as="a"
									className={Styles.allWinners}
									href={this.redirectUrl()}
									size="lg"
									styleType="primary"
									treatAs="link"
								>
									See All Winners
								</CtaButton>
							</GridColumn>
						</GridRow>
						{this.shouldDisplayBowInfo() && (
							<div className={Styles.resultsHeader}>{this.renderBowInfo()}</div>
						)}
					</GridColumn>
					<GridColumn lg="1" />
				</GridRow>
				<div className={Styles.reviewSection}>
					<GridContainer>
						<GridRow>
							<GridColumn md="10" className={Styles.writeReview}>
								<div className={Styles.reviewText}>
									{this.writeReviewText()}
								</div>
								<div>
									<CtaButton
										as="a"
										className={Styles.allWinners}
										href="/review-wedding-vendors"
										size="md"
										styleType="secondary"
										treatAs="link"
									>
										Review Vendors
									</CtaButton>
								</div>
							</GridColumn>
						</GridRow>
						<GridRow>
							<GridColumn md="6" className={Styles.advertiseText}>
								Wedding Professional?&nbsp;
								<a href={tkProUrl}>Advertise with us</a>
							</GridColumn>
						</GridRow>
					</GridContainer>
				</div>
			</>
		);
	}
}
